<script>
let id = 1000
let fromData = ''
let toData = ''
let fromParentModelChildren = ''
let nodeClicked = null

import moment from 'moment'
import LogTransacaoEnum from '../../enum/logTransacao'
import SituacaoTarefaEnum from '../../enum/situacaoTarefa'

export default {
  name: 'TreeviewHistoric',

  props: {
    model: Object,
    buttonsTitle: Object,
    clickFunction: Function,
    id: String,
    father: Object,
    defaultText: String,
    currentHighlight: Boolean,
    hoverColor: String,
    highlightColor: String,
    spaceLeft: String,
    styleObj: Object
  },

  data: function () {
    return {
      open: true,
      isClicked: true,
      title: '',
      situation: '',
      dateFomated: null
    }
  },

  computed: {
    isFolder () {
      return this.model.children &&
        this.model.children.length
    }
  },

  template: `<div class="treeviewHistoric">
              <div :id='model.id' draggable='false' @dragstart='dragStart' @dragover='dragOver' @dragenter='dragEnter' @dragleave='dragLeave' @drop='drop' @dragend='dragEnd' class='col-xs-12 acaoMain pl-0' @mouseover='mouseOver' @mouseout='mouseOut' :style='styleObj'>
                <button v-if="!isClicked" :title="[buttonsTitle && buttonsTitle.expand ? buttonsTitle.expand : '']" @click="toggle" class="fa fa-plus-square px-0 action btn-fa-expand"></button>
                <button v-if="isClicked" :title="[buttonsTitle && buttonsTitle.collapse ? buttonsTitle.collapse : '']" @click="toggle" class="fa fa-minus-square px-0 action btn-fa-expand"></button>
                <div :style='spaceLeft' class="col-xs-10 pl-0">
                  {{title}} | {{dateFomated}}
                </div>
              </div>
              <div class="clear"></div>
              <div v-if="!open" style="min-height:20px;"></div>
              <div v-if="open" class="childrenObject">
                <div style="margin-bottom:5px;">{{model.usuario && model.usuario.nome ? model.usuario.nome : '-'}}</div>
                <div><b>{{situation != null ? situation : '-'}}</b></div>
                <div>{{model.descricao ? model.descricao : '-'}}</div>
              </div>
            </div>`,

  methods: {
    getTitLabel () {
      this.title = this.$t('logTransacao.' + LogTransacaoEnum[this.model.idTransacao])
    },

    getSituationTaskLabel () {
      this.situation = this.model.situacao != null
        ? this.$t('situacaoTarefa.' + SituacaoTarefaEnum[this.model.situacao])
        : null
    },

    getDateFormated () {
      this.dateFomated = moment(this.model.data).format('lll')
    },

    toggle () {
      this.open = !this.open
      let rootTree = this.findRoot()

      this.isClicked = !this.isClicked

      if (this.currentHighlight) {
        if (nodeClicked !== this.model.id) {
          let treeParent = rootTree.$parent
          let nodeStack = [treeParent.$children[0]]
          while (nodeStack.length !== 0) {
            let item = nodeStack.shift()
            item.styleObj.background = 'white'
            if (item.$children && item.$children.length > 0) {
              nodeStack = nodeStack.concat(item.$children)
            }
          }
          this.styleObj.background = this.highlightColor ? this.highlightColor : '#99A9BF'
          nodeClicked = this.model.id
        }
      }
    },

    exchangeData (rootCom, from, to) {
      if (!to || !from || typeof to === 'string' || from.id === to.id) {
        return
      }

      from = JSON.parse(JSON.stringify(from))
      to = JSON.parse(JSON.stringify(to))
      // copy
      let treeData = JSON.parse(JSON.stringify(this.model))
      let nodeStack = [treeData]
      let status = 0

      try {
        while (!(status === 2)) {
          let item = nodeStack.shift()
          if (item.id === from.id) {
            item.id = to.id
            item.name = to.name
            if (to.children && to.children.length > 0) {
              item['children'] = to.children
            } else {
              item.children = []
            }
            status++
            continue
          }
          if (item.id === to.id) {
            item.id = from.id
            item.name = from.name
            if (from.children && from.children.length > 0) {
              item['children'] = from.children
            } else {
              item.children = []
            }
            status++
            continue
          }
          if (item.children && item.children.length > 0) {
            nodeStack = nodeStack.concat(item.children)
          }
        }
      } catch (e) {
        return
      }
      rootCom.assignData(treeData)
    },

    changeType () {
      if (this.currentHighlight) {
        nodeClicked = this.model.id
      }
      if (!this.isFolder) {
        this.$set(this.model, 'children', [])
        this.addChild()
        this.open = true
        this.isClicked = true
      }
    },

    mouseOver (e) {
      if (this.styleObj) {
        if ((this.styleObj.background !== '#99A9BF' || this.styleObj.background !== this.hightlightColor) && e.target.className === 'treeNodeText') {
          e.target.style.background = this.hoverColor ? this.hoverColor : '#E5E9F2'
        }
      }
    },

    mouseOut (e) {
      if (this.styleObj) {
        if ((this.styleObj.background !== '#99A9BF' || this.styleObj.background !== this.hightlightColor) && e.target.className === 'treeNodeText') {
          e.target.style.background = 'white'
        }
      }
    },

    findRoot () {
      let ok = false
      let that = this
      while (!ok) {
        if (!/VueDragTreeCom42/.test(that.$parent.$vnode.tag) || that.$parent.data) {
          ok = true
          break
        }
        that = that.$parent
      }
      return that
    },

    addChild () {
      this.model.children.push({
        name: this.defaultText ? this.defaultText : 'New Node',
        id: id++
      })
    },

    removeChild (id) {
      let parentModelChildren = this.$parent.model.children
      for (let index in parentModelChildren) {
        if (parentModelChildren[index].id === id) {
          parentModelChildren = parentModelChildren.splice(index, 1)
          break
        }
      }
    },

    dragStart (e) {
      e.dataTransfer.effectAllowed = 'move'
      e.dataTransfer.setData('nottext', e.target.innerHTML)
      return true
    },

    dragEnd (e) {
      fromData = undefined
      toData = undefined
      fromParentModelChildren = undefined
    },

    dragOver (e) {
      e.preventDefault()
      return true
    },

    dragOverPlus (e) {
      e.preventDefault()
    },

    dragEnterPlus (e) {
    },

    dragEnter (e) {
      toData = this.model
      let rootTree = this.findRoot()
      rootTree.exchangeData(rootTree.$parent, fromData, toData)
    },

    dragLeave (e) {
      fromData = this.model
      fromParentModelChildren = this.$parent.model.children
    },

    drop (e) {
    },

    dropPlus (e) {
      if (this.model.hasOwnProperty('children')) {
        this.model.children.push(fromData)
      } else {
        this.model.children = [fromData]
      }
      for (let i in fromParentModelChildren) {
        if (fromParentModelChildren[i].id === fromData.id) {
          fromParentModelChildren.splice(i, 1)
        }
      }
    }
  },

  beforeCreate () {
    this.$options.components.item = require('./TreeviewHistoric')
  },

  mounted () {
    this.getTitLabel()
    this.getSituationTaskLabel()
    this.getDateFormated()
  }
}
</script>

<style>
.treeviewHistoric {
  font-family: 'Inter', sans-serif;
  min-height: 20px;
  padding: 0px 5px;
  line-height: initial;
}

.childrenObject {
  border-left: 1px solid #046582;
  margin-left: 16px;
  padding: 8px 0px 12px 17px;
  font-family: 'Inter', sans-serif;
font-weight: 400;
  color: #2A2A2A;
  font-size: 14px;
}

.acaoMain {
  font-family: 'Inter', sans-serif;
font-weight: 700;
  color: #046582;
  font-size: 14px;
  margin-bottom: -2px;
  height: 16px;
  border: none;
  padding-bottom: 0px;
  margin-top: -2px;
}

button.buttons-actions-treeview {
  width:23px;
  float:right;
}

.no-button-chevron {
  width:32px;
  float:right;
  height:14px;
}

.treeRow {
  padding-top: 5px;
  padding-bottom: 5px;
  border-bottom: none;
}

.treeRowBg {
  background: #617a95 !important;
  border: solid 1px #3c5e82;
  font-weight: bold;
  color: #ffffff;
}

button.action.btn-fa-expand {
  color: #046582;
  border: none !important;
  margin: 1px 5px 0 5px;
  width:23px;
  float:left;
}

.item {
  cursor: pointer;
}

.bold {
  font-weight: bold;
}

.treeNodeText {
  margin: 2px;
  padding: 0.2rem 0.5rem;
  width: fit-content;
  background: #F9FAFC;
  font-size: 18px;
  color: #324057;
}

.treeMargin {
  margin-left: 0px;
}

.changeTree {
  width: 1rem;
  color: #324057;
}

.vue-drag-node-icon {
  display: inline-block;
  width: 0;
  height: 0;
  padding-right: 3px;
  border-left: 6px solid black;
  border-top: 6px solid transparent;
  border-bottom: 6px solid transparent;
  border-right: 0 solid yellow;
  transition: transform .3s ease-in-out;
}

.nodeClicked {
  transform: rotate(90deg);
}
</style>



// WEBPACK FOOTER //
// TreeviewHistoric.vue?769545b9